import { render, staticRenderFns } from "./Payroll.vue?vue&type=template&id=3b1b0bb0&scoped=true"
import script from "./Payroll.vue?vue&type=script&lang=ts"
export * from "./Payroll.vue?vue&type=script&lang=ts"
import style0 from "./Payroll.vue?vue&type=style&index=0&id=3b1b0bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b0bb0",
  null
  
)

export default component.exports